module.exports = __webpack_public_path__ + "static/media/Oval.adc3903f.svg";